import { css, keyframes, type Theme } from '@emotion/react';
import { Hourglass } from '@phosphor-icons/react';
import { useDeploymentClientState } from 'client/state/DeploymentClientState';
import { useDeploymentEnabledState } from 'client/pages/deployment/useDeploymentEnabledState';
import { Time } from 'client/components/Time';
import { Tooltip } from 'client/components/Tooltip';
import { Typography } from 'client/components/Typography';

export const ScheduleStatus = () => {
  const deploymentID = useDeploymentClientState((state) => state?.document?.id || null);
  const { enabled, timeRunUntil } = useDeploymentEnabledState({ deploymentID });

  const isHourglassAnimated = timeRunUntil ? new Date(timeRunUntil).getTime() - Date.now() < 30 * 60 * 1000 : false;

  if (enabled && timeRunUntil) {
    return (
      <Tooltip title="Deployment was enabled with a shutdown timer" side="top">
        <Typography variant="body2" css={textStyle}>
          <Hourglass weight="fill" css={[isHourglassAnimated && spinAnimationStyle]} />{' '}
          <Time prefix="Shutting down " dateTime={timeRunUntil} />
        </Typography>
      </Tooltip>
    );
  }

  return null;
};

const textStyle = css`
  display: flex;
  align-items: center;
  user-select: none;
  gap: 3px;
`;

const spinAnimation = keyframes`
  0% { transform: rotate(0deg) };
  60% { transform: rotate(180deg) };
  100% { transform: rotate(180deg) };
`;

const spinAnimationStyle = (theme: Theme) => css`
  animation: ${spinAnimation} 2s infinite ${theme.easing.basic};
`;
